<template>
  <div>
    <div class="box">
      <p style="margin-top:7.8pt; margin-bottom:10pt; text-align:center; line-height:24pt; background-color:#ffffff" v-if="userProtocolName">
        <span style="font-family:'宋体'; font-size:16pt; font-weight:bold; color:#2c3e50; background-color:#ffffff">《{{userProtocolName}}》</span>
      </p>
      <a-spin :spinning="loading">
        <div class="content-text ql-bubble">
          <div class="ql-editor" v-html="agreeData"></div>
        </div>
      </a-spin>
  </div>
  <div class="btn-footer" v-if="form">
    <div class="btn-view">
      <div class="yes" @click="agree('yes')">阅读并同意</div>
    </div>
  </div>
</div>
</template>

<script>
import { getSysAgreementByType } from '@/api/login/index'

export default {
  name: '',
  data () {
    return {
      userProtocolName: '',
      form: '',
      agreeData: '',
      loading: false
    }
  },
  created () {
    document.documentElement.scrollTop = 0
    document.body.scrollTop = 0
    document.title = '麦德通'
    let hm = document.createElement('script')
    hm.async = true
    hm.src = 'https://res.wx.qq.com/open/js/jweixin-1.3.2.js'
    let s = document.getElementsByTagName('script')[0]
    s.parentNode.insertBefore(hm, s)
    this.form = this.getUrlParam('form')
    this.getAgreeData()
  },
  methods: {
    getAgreeData () {
      this.loading = true
      getSysAgreementByType({ agreementType: this.$route.query.agreementType || 0 })
        .then(({ code, msg, data }) => {
          if (code === 0) {
            const { agreementValue = '', userProtocolName } = data || {}
            this.agreeData = agreementValue
            this.userProtocolName = userProtocolName
          } else {
            this.$message.error(msg || '系统繁忙，请稍后重试')
          }
        })
        .catch((e) => {
          this.$message.error('系统繁忙，请稍后重试')
        })
        .finally(() => {
          this.loading = false
        })
    },
    getUrlParam (name) {
      var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
      var r = window.location.search.substr(1).match(reg)
      if (r != null) return unescape(r[2])
      return null
    },
    agree (type) {
      var ua = window.navigator.userAgent.toLowerCase()
      if (ua.match(/MicroMessenger/i) == 'micromessenger') {
        // ios的ua中无miniProgram，但都有MicroMessenger（表示是微信浏览器）
        wx.miniProgram.getEnv((res) => {
          if (res.miniprogram) {
            wx.miniProgram.navigateBack({ delta: 1 })
            wx.miniProgram.postMessage({
              data: {
                clickData: type
              }
            })
          } else {
            alert('不在小程序里')
          }
        })
        //  wx.miniProgram.navigateTo({url:'/pages/buy/buy'});
      } else {
        alert('不在微信里')
      }
    }
  }
}
</script>
<style scoped>.T5 {
  color: #2c3e50;
  font-family: Helvetica;
  font-size: 14pt;
  background-color: #ffffff;
}

.content-text p {
  margin-top: 10px;
}

.btn-footer {
  position: fixed;
  left: 0;
  width: 100%;
  bottom: 0;
  background: white;
  box-shadow: 0px -4px 20px 0px rgba(0, 0, 0, 0.2);
}

.btn-view {
  display: flex;
  padding: 0.3rem 0;
  width: 2rem;
  justify-content: space-between;
  margin: auto;
}

.no {
  background: white;
  color: #4FA9FD;
  border: 1px solid #4FA9FD;
}

.yes {
  background: #4FA9FD;
  color: white;
}

.btn-view div {
  /* width: 40%; */
  height: 0.8rem;
  border-radius: 1px solid #4FA9FD;
  text-align: center;
  line-height: 0.8rem;
  border-radius: 6px;
  font-size: 0.28rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  padding: 0 0.2rem;
}

.box {
  padding: 0.4rem 0.4rem 1rem 0.4rem;
  text-align: left;
}

.subtitle {
  font-size: 20px;
  font-weight: 600;
  font-family: 宋体;
  margin: 20px 0 !important;
}

.small-title {
  font-size: 16px;
  font-weight: 600;
  font-family: 宋体;
}
</style>



// WEBPACK FOOTER //
// src/views/agreezc.vue